import { AlertGroupSelectByIdOutputData } from './alert-group-select-by-id-output-data.model';


export class AlertGroupSelectByIdOutput implements IAlertGroupSelectByIdOutput {
    status!: number;
    message!: string;
    data!: AlertGroupSelectByIdOutputData;

    constructor(data?: IAlertGroupSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? AlertGroupSelectByIdOutputData.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AlertGroupSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new AlertGroupSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAlertGroupSelectByIdOutput {
    status: number;
    message: string;
    data: AlertGroupSelectByIdOutputData;
}

